import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/",
    component: () => import("../views/guest/layouts/LayoutView.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/guest/HomeView.vue"),
      },
      {
        path: "/about",
        component: () => import("../views/guest/AboutView.vue"),
      },
      {
        path: "/repeat",
        component: () => import("../views/guest/RepeatView.vue"),
      },
      {
        path: "/grad",
        component: () => import("../views/guest/GradView.vue"),
      },
      {
        path: "/marks",
        component: () => import("../views/guest/MarkView.vue"),
      },
      {
        path: "/objection",
        component: () => import("../views/guest/ObjectionView.vue"),
      },
      {
        path: "/downsub",
        component: () => import("../views/guest/DownsubView.vue"),
      },
      {
        path: "/ads",
        component: () => import("../views/guest/AdsView.vue"),
      },
    ],
  },

  {
    path: "/admin",
    name: "admin",
    meta: {
      auth: true,
    },
    component: () => import("../views/admin/layouts/LayoutView.vue"),

    children: [
      {
        path: "",
        component: () => import("../views/admin/AdminHome.vue"),
      },
      {
        path: "subjects",
        component: () => import("../views/admin/AdminSubjects.vue"),
      },
      {
        path: "repeats",
        component: () => import("../views/admin/AdminRepeats.vue"),
      },
      {
        path: "grads",
        component: () => import("../views/admin/AdminGrads.vue"),
      },
      {
        path: "marks",
        component: () => import("../views/admin/AdminMarks.vue"),
      },
      {
        path: "objections",
        component: () => import("../views/admin/AdminObjections.vue"),
      },
      {
        path: "downsubs",
        component: () => import("../views/admin/AdminDownsubs.vue"),
      },
      {
        path: "students",
        component: () => import("../views/admin/AdminStudents.vue"),
      },
      {
        path: "settings",
        component: () => import("../views/admin/AdminSettings.vue"),
      },
      {
        path: "messages",
        component: () => import("../views/admin/AdminMessages.vue"),
      },
      {
        path: "articles",
        component: () => import("../views/admin/AdminArticles.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const sessionLoggedIn = () =>
    localStorage.getItem("user") != null ? true : false;
  //const user = JSON.parse(localStorage.getItem("user"));

  //console.log("user", user);
  // console.log("to", to);

  if (to.path == "/login" && sessionLoggedIn()) {
    next("/admin");
    return;
  }
  if (to.meta.auth && !sessionLoggedIn()) {
    next("/login");
    return;
  }
  next();
});

export default router;
